import { render, staticRenderFns } from "./compression-info-bjsz.vue?vue&type=template&id=050ccbe5&scoped=true"
import script from "./compression-info-bjsz.vue?vue&type=script&lang=js"
export * from "./compression-info-bjsz.vue?vue&type=script&lang=js"
import style0 from "./compression-info-bjsz.vue?vue&type=style&index=0&id=050ccbe5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050ccbe5",
  null
  
)

export default component.exports